const EXCLUSIVE = {
  ALL: 'all'
};

export {EXCLUSIVE};



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestsFilters/teamRequestsFilters.constants.js